import { ServiceOrder } from './service-order.model';
import { isClosedStatus } from './service-order.labels';

export type DetailTextKey = 'problems' | 'notes' | 'closeNotes';

export interface DetailSection {
  key: DetailTextKey;
  labelKey: string;
  /** null = seção presente mas vazia: mantém a altura estável entre OS **/
  value: string | null;
  emptyKey: string;
}

function trimmed(value: string | null | undefined): string | null {
  return value?.trim() || null;
}

/**
 * Seções de texto da OS, na ordem em que o relato é lido: defeitos, observação, relatório.
 * Defeitos e observação sempre presentes (com "—" quando vazias); o relatório de fechamento
 * só existe para OS fechada ou quando alguém já escreveu nele.
 **/
export function buildDetailSections(serviceOrder: ServiceOrder | null | undefined): DetailSection[] {
  const sections: DetailSection[] = [
    {
      key: 'problems',
      labelKey: 'service-order.problems-label',
      value: trimmed(serviceOrder?.problems),
      emptyKey: 'service-order.no-problems-informed',
    },
    {
      key: 'notes',
      labelKey: 'service-order.notes-label',
      value: trimmed(serviceOrder?.notes),
      emptyKey: 'service-order.not-informed',
    },
  ];

  if (isClosedStatus(serviceOrder?.status ?? null) || trimmed(serviceOrder?.closeNotes)) {
    sections.push({
      key: 'closeNotes',
      labelKey: 'service-order.close-notes-label',
      value: trimmed(serviceOrder?.closeNotes),
      emptyKey: 'service-order.not-informed',
    });
  }

  return sections;
}

/** Só as seções com texto: é o que o cartão de resumo da tabela mostra **/
export function filledDetailSections(serviceOrder: ServiceOrder | null | undefined): DetailSection[] {
  return buildDetailSections(serviceOrder).filter(section => section.value);
}

/** Alguma das três caixas de texto tem conteúdo? Sem isso o cartão de resumo não abre **/
export function hasDetailText(serviceOrder: ServiceOrder | null | undefined): boolean {
  return filledDetailSections(serviceOrder).length > 0;
}
